// extracted by mini-css-extract-plugin
export default {"tabs":"collection_tabs__FCvLk","tab":"collection_tab__Hvp0Z","active":"collection_active__F8m1N","contents":"collection_contents__dCQDv"};